import { render, staticRenderFns } from "./IconFilter.vue?vue&type=template&id=79874771&"
import script from "./IconFilter.vue?vue&type=script&lang=ts&"
export * from "./IconFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports